"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAuthorshipAuthorProperty = exports.authorshipAuthorPropertyDefinition = void 0;
exports.authorshipAuthorPropertyDefinition = {
    view: { label: 'Authorship Author' },
    constraints: [
        {
            name: 'maxLength',
            argument: 80,
        },
    ],
    type: 'text',
    multiple: false,
    name: 'authorship-author',
};
const isAuthorshipAuthorProperty = (prop) => {
    return prop.name === exports.authorshipAuthorPropertyDefinition.name;
};
exports.isAuthorshipAuthorProperty = isAuthorshipAuthorProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiYXV0aG9yc2hpcC1hdXRob3IucHJvcGVydHkuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvcHJvcGVydGllcy9hdXRob3JzaGlwLWF1dGhvci5wcm9wZXJ0eS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFFYSxRQUFBLGtDQUFrQyxHQUFHO0lBQ2hELElBQUksRUFBRSxFQUFFLEtBQUssRUFBRSxtQkFBbUIsRUFBRTtJQUNwQyxXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxXQUFXO1lBQ2pCLFFBQVEsRUFBRSxFQUFFO1NBQ2I7S0FDRjtJQUNELElBQUksRUFBRSxNQUFNO0lBQ1osUUFBUSxFQUFFLEtBQUs7SUFDZixJQUFJLEVBQUUsbUJBQW1CO0NBQ00sQ0FBQTtBQUkxQixNQUFNLDBCQUEwQixHQUFHLENBQUMsSUFBa0IsRUFBb0MsRUFBRTtJQUNqRyxPQUFPLElBQUksQ0FBQyxJQUFJLEtBQUssMENBQWtDLENBQUMsSUFBSSxDQUFBO0FBQzlELENBQUMsQ0FBQTtBQUZZLFFBQUEsMEJBQTBCLDhCQUV0QyJ9